import { createFileRoute } from '@tanstack/react-router';

import { EditorialTeamBrowse } from '@/module/Author/EditorialTeam';

export const Route = createFileRoute('/_auth/author/_author/editorial-team/_editorialTeam/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <EditorialTeamBrowse />;
}
